<template>
  <section>
    <div class="modal-body">
      <p class="page-title mb-5">
       {{ tourData.isPass ? $t('booking.bookNow') : $t('booking.reserveSpot') }} 
      </p>

      <!--  <p class="has-text-success mb-4"><b-icon icon="lock"></b-icon><strong class="has-text-success">Safe and
          secure</strong> payment processing guaranteed</p> -->

      <b-tabs
        v-model="activeTab"
        position="is-centered"
        size="is-small"
        expanded
        :animated="false"
      >
        <b-tab-item>
          <b-field :label="$t('booking.name')" class="mt-4 mb-4">
            <b-input required v-model="fullName"></b-input>
          </b-field>

          <b-field :label="$t('booking.phone')" class="mb-4">
            <vue-tel-input
              ref="phoneInput"
              class="input"
              :mode="'international'"
              :inputOptions="{
                showDialCode: true,
                inputmode: 'numeric',
                pattern: '[0-9]*',
                type: 'tel',
                placeholder: $t('booking.phonePlaceholder'),
              }"
              validCharactersOnly
              v-model="phoneNumber" :placeholder="$t('booking.phonePlaceholder')"
            />
          </b-field>

          <b-field :label="$t('booking.email')" class="mb-4">
            <b-input required type="email" v-model="email"></b-input>
          </b-field>

          <b-field
            :label="$t('booking.experienceType')"
            class="mb-4"
            v-if="!tourData.isPrivateOnly"
          >
            <div class="columns is-mobile">
              <div class="column is-6">
                <div
                  class="tour-type--cnt"
                  @click="isPrivateTour = true"
                  :class="{ selected: isPrivateTour }"
                >
                  <div class="is-flex is-align-items-center">
                    <img :src="lockedIcon" class="mr-1 icon" />
                    <b>{{ $t("booking.private") }}</b>
                  </div>
                </div>
              </div>
              <div class="column">
                <div
                  class="tour-type--cnt"
                  @click="isPrivateTour = false"
                  :class="{ selected: !isPrivateTour }"
                >
                  <div class="is-flex is-align-items-center">
                    <img :src="unlockedIcon" class="mr-1 icon" />
                    <b>{{ $t("booking.shared") }}</b
                    ><b-tooltip
                      position="is-left"
                      multilined
                      :label="$t('booking.sharedTooltip')"
                    >
                      <img
                        src="../../assets/info-circle.png"
                        class="icon is-flex ml-1"
                      />
                    </b-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </b-field>
        </b-tab-item>

        <b-tab-item>
          <!--      <b-field label="Date" class="mt-4 date" >

            <b-datepicker inline  ref="datepicker" v-model="bookingDate" :min-date="minDate"
              :max-date="maxDate">
            </b-datepicker>

          </b-field> 

           <b-field label="Date" class="mt-4" grouped>
              <b-button class="calendar-icon mr-2" type="is-primary"><img class="mt-1"
                   src="../../assets/calendar--white.svg" /></b-button> 
                   <b-datepicker expanded  ref="datepicker" v-model="bookingDate" :min-date="minDate"
                   :max-date="maxDate">
   
                <template v-slot:trigger>
                   <b-input @click="$refs.datepicker.toggle()" expanded readonly :value="humanizedDate" />
                 </template>
</b-datepicker>

</b-field>-->
          <InlineMessageContainer
            v-if="tourData.isPass"
            class="mt-5"
            :text="$t('booking.passValidity')"
          />

          <b-field :label="$t('booking.date')" class="mt-4 mb-5" grouped>
            <b-button icon-left="calendar" class="calendar-icon mr-2" type="is-primary"
              ></b-button>

            <!-- <b-datepicker
              expanded
              ref="datepicker"
              v-model="bookingDate"
              :mobile-native="false"
              :min-date="tourData.isPrivateOnly ? dateTomorrow : minDate"
              :max-date="maxDate"
            > -->
            <b-datepicker
              expanded
              ref="datepicker"
              v-model="bookingDate"
              :locale="dateLocale"
              :mobile-native="false"
              :unselectable-dates="disabledDates"
              :min-date="minDate"
              :max-date="maxDate"
              :events="soldOutDates"
              indicators="bars"
            >
              <template v-slot:trigger>
                <b-input
                  @click="$refs.datepicker.toggle()"
                  expanded
                  readonly
                  :value="humanizedDate"
                />
              </template>
              <div class="is-flex is-align-items-center">
                <div class="sold-out-bar"></div>
                <b>{{ $t("booking.soldOut") }}</b>
              </div>
            </b-datepicker>
          </b-field>
          <b-tag
            class="mb-3 available-tag"
            icon="bolt"
            type="is-success is-light"
            v-if="bookingDate"
          >
            <span>{{ $t("booking.availableTickets", { count: availableTickets }) }}</span>
          </b-tag>

          <b-field :label="$t('booking.time')" class="mt-4 timeslots" v-if="!tourData.isPass">
            <b-radio-button
              :disabled="isTimeValid(time)"
              v-model="bookingTime"
              v-for="(time, index) in timeSlots"
              :key="index"
              :native-value="time"
              type="is-primary"
              >{{ time }}</b-radio-button
            >
          </b-field>
          <div v-if="!bookingDate && !tourData.isPass" class="help is-flex">
            <p class="is-flex is-align-items-center">
              <b-icon icon="info-circle"></b-icon> {{ $t("booking.chooseDateFirst") }}
            </p>
          </div>
          <div class="info is-flex" v-if="!tourData.isPass && bookingDate">
            <i18n path="booking.otherTime" tag="p">
              <template #email>
                <a class="link" href="mailto:support@guiders.pt">{{ $t("booking.emailUs") }}</a>
              </template>
              <template #whatsapp>
                <a class="link" href="https://wa.me/351920043375" target="_blank">{{ $t("booking.whatsapp") }}</a>
              </template>
            </i18n>
          </div>

          <b-field
            :label="$t('booking.participants')" class="mt-4 is-flex is-align-items-center is-justify-content-space-between"
          >
            <b-numberinput
              class="participants-field mb-4"
              type="is-primary"
              v-model="participants"
              min="1"
              :max="maxNumOfParticipants"
              controls-alignment="right"
              :editable="false"
            ></b-numberinput>
          </b-field>
          <b-field
            class="radio--input"
            v-if="$route.params.id === 'Wtc6b2YdHZo9lvHllBuZ'"
          >
            <div @click.prevent="isTicketUpgraded = !isTicketUpgraded">
              <b-checkbox v-model="isTicketUpgraded"
                ><b>{{ $t("booking.upgradeTitle") }}</b>
              </b-checkbox>
              <p>{{ $t("booking.upgradeText") }}</p>
              <p>+ €7.50</p>
            </div>
          </b-field>
        </b-tab-item>

        <b-tab-item :disabled="!isBookingValid">
          <div class="columns is-mobile mt-5 mb-5">
            <!--  <div class="column pr-1 is-narrow">
              <img class="is-rounded tour--img" :src="tourData.coverImage" />
            </div> -->

            <div class="column">
              <p class="is-size-5 mt-2 has-text-weight-bold">
                {{ displayTitle || tourData.title }}
              </p>

              <div class="mt-2 is-flex tags" v-if="!tourData.isPass">
                <div class="is-flex is-align-items-center mr-4">
                  <img src="../../assets/Calendar.svg" class="icon mr-1" />{{
                    formatDay(bookingDate)
                  }}
                </div>

                <div class="is-flex is-align-items-center">
                  <img src="../../assets/time-circle.png" class="icon mr-1" />{{
                    bookingTime
                  }}
                </div>
              </div>
            </div>
          </div>

          <div v-if="!tourData.isPass">
            <p class="is-size-5 mb-4 mt-1 has-text-weight-bold">
              {{ $t("booking.orderDetails") }}
            </p>

            <div class="display-flex-space-btw mb-2">
              <b>{{ $t("booking.payGuide") }}</b>
              <p>{{ guiderPayment }} €</p>
            </div>

            <div class="display-flex-space-btw mb-4">
              <div class="is-flex is-align-items-center">
                <b>{{ $t("booking.payNow") }}</b>
              </div>

              <p>{{ websiteFee }}</p>
            </div>

            <div class="separator mt-5 mb-5"></div>

            <div class="display-flex-space-btw">
              <b>{{ $t("booking.total") }}</b>
              <p>
                {{ tourData.privatePrice.toFixed(2) }}
                €
              </p>
            </div>
          </div>

          <div v-else>
            <div class="display-flex-space-btw mb-3">
              <p class="has-text-weight-semibold">{{ $t("booking.leadPassenger") }}</p>
              <p class="has-text-weight-light">
                {{ this.fullName }}
              </p>
            </div>

            <div class="display-flex-space-btw mb-3">
              <p class="has-text-weight-semibold">{{ $t("booking.email") }}</p>
              <p class="has-text-weight-light">
                {{ this.email }}
              </p>
            </div>

            <div class="separator mt-5 mb-5"></div>

            <div class="display-flex-space-btw">
              <p>
                {{ participants }} {{ participants > 1 ? $t("booking.tickets") : $t("booking.ticket") }}
              </p>
              <p>
                {{ parseFloat(tourData.price * participants).toFixed(2) }}
                €
              </p>
            </div>

            <div class="separator mt-5 mb-5"></div>

            <div class="display-flex-space-btw">
              <b>{{ $t("booking.total") }}</b>
              <p>
                {{ parseFloat(tourData.price * participants).toFixed(2) }}
                €
              </p>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>

      <b-button
        v-if="activeTab === 1 || activeTab === 2"
        class="is-large mb-3"
        type="is-primary is-outlined"
        expanded
        rounded
        @click="activeTab -= 1" >{{ $t("booking.previous") }}</b-button>

      <b-button
        v-if="activeTab === 0 || activeTab === 1"
        class="is-large"
        expanded
        rounded
        type="is-primary"
        @click="activeTab += 1"
        :disabled="isNextBtnDisabled" >{{ $t("booking.next") }}</b-button>

      <div v-else>
        <!-- Admins only: the same purchase with Stripe's test card, no real charge -->
        <b-checkbox v-if="tourData.isPass && isAdmin" v-model="testPurchase" class="mb-3">
          Test purchase: pay with card 4242 4242 4242 4242, any future date and CVC. Nothing is charged.
        </b-checkbox>
        <!--  <b-button class="is-large" expanded rounded type="is-primary" @click="redirect"
          :disabled="!isBookingValid && activeTab === 2" :loading="isLoadingBooking">Book for {{ isPrivateTour ?
        privatePrice.toFixed(2) : (tourData.price *
          participants).toFixed(2) }} €</b-button> -->
        <b-button
          v-if="!tourData.isPass"
          class="is-large"
          expanded
          rounded
          type="is-primary"
          @click="redirect"
          :disabled="!isBookingValid && activeTab === 2"
          :loading="isLoadingBooking"
          >{{ $t("booking.reserveFor", { price: websiteFee }) }}</b-button
        >

        <b-button
          v-else
          class="is-large"
          expanded
          rounded
          type="is-primary"
          @click="redirect"
          :disabled="!isBookingValid && activeTab === 2"
          :loading="isLoadingBooking" >{{ $t("booking.confirmPay") }}</b-button
        >
      </div>
    </div>
  </section>
</template>

<script>
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { db } from "../../firebase";
import { mapState } from "vuex";
import { UsersStates } from "../../store/Storetypes";
import { authHeaders } from "@/services/authApi";
import InlineMessageContainer from "../InlineMessageContainer.vue";
import { currentLocaleInfo } from "@/i18n";
import {
  dateWithMonthAndDay,
  convertMinutesToHoursAndMinutes,
  addDurationToTime,
} from "../../helpers";
export default {
    // displayTitle: the tour title in the visitor's language (the tour data
  // itself stays English for payments)
  props: ["originalTourData", "fullName", "email", "displayTitle"],
  components: {
    InlineMessageContainer,
  },
  data() {
    const today = new Date();
    const min = new Date();
    min.setHours(10);
    min.setMinutes(0);

    const max = new Date();
    max.setHours(22);
    max.setMinutes(0);
    return {
      ticketsByDate: {}, // { "2025-06-02": 23, "2025-06-03": 50, ... }
      disabledDates: [],
      soldOutDates: [],
      MAX_TICKETS: 50,
      dateWithMonthAndDay,
      convertMinutesToHoursAndMinutes,
      addDurationToTime,
      dateTomorrow: new Date(today.getTime() + 24 * 60 * 60 * 1000),
      date: new Date(),
      activeTab: 0,
      maxDate: new Date(
        today.getFullYear(),
        today.getMonth() + 10,
        today.getDate(),
      ),
      minTime: min,
      maxTime: max,
      defaultSharedTimeSlots: ["10:00", "14:00"],
      defaultPrivateTimeSlots: [
        "10:00",
        "11:00",
        "12:00",
        "13:00",
        "14:00",
        "15:00",
        "16:00",
        "17:00",
        "18:00",
      ],
      isBookingValid: false,
      isTicketUpgraded: false,
      isBillingValid: false,
      isLoadingBooking: false,
      testPurchase: false,
      bookingDate: null,
      bookingTime: "",
      participants: 1,
      isPrivateTour: true,
      subscribeClientToNewsletter: false,
      nOfPrivateTickets: 1,
      phoneNumber: "",
    };
  },
  computed: {
    dateLocale() {
      return currentLocaleInfo().dateLocale;
    },
    ...mapState({
      user: (state) => state.users[UsersStates.USER],
      isAdmin: (state) => state.users[UsersStates.IS_ADMIN],
    }),
    maxNumOfParticipants() {
      if (this.tourData?.isPass) {
        return this.availableTickets;
      }
      return this.tourData.maxNumOfParticipants;
    },
    availableTickets() {
      if (!this.bookingDate) return null;
      const dateStr = this.formatDate(this.bookingDate);
      const taken = this.ticketsByDate[dateStr] || 0;
      return this.MAX_TICKETS - taken >= 0 ? this.MAX_TICKETS - taken : 0;
    },
    lockedIcon() {
      if (this.isPrivateTour)
        return require("../../assets/lock-closed--white.svg");
      return require("../../assets/lock--closed.png");
    },
    unlockedIcon() {
      if (!this.isPrivateTour)
        return require("../../assets/lock-open--white.svg");
      return require("../../assets/lock--opened.png");
    },
    isNextBtnDisabled() {
      if (this.activeTab === 0) {
        return (
          !this.fullName.length ||
          !this.email.length ||
          !this.isValidPhoneNumber(this.phoneNumber)
        );
      }
      if (this.activeTab === 1) {
        return !this.isBookingValid;
      }
      return false;
    },
    guiderPayment() {
      /* const nOfTickets = Math.ceil(this.participants / 4)
      const sharedTourPayment = (this.tourData.price *
        this.participants).toFixed(2) - (10 * this.participants).toFixed(2)
      const price = this.isPrivateTour ? (this.tourData.guiderPayment * nOfTickets).toFixed(2) : sharedTourPayment
      return Number(price) */

      /*   const nOfTickets = Math.ceil(this.participants / 4);
      const sharedTourPayment =
        (this.tourData.price * this.participants).toFixed(2) -
        (10 * this.participants).toFixed(2);

      if (this.isPrivateTour) {
        if (this.tourData.isPrivateOnly) {
          return this.privatePrice - 20;
        }
        if (this.participants === 5) {
          return Number(this.tourData.guiderPayment + 7.5).toFixed(2);
        }

        if (this.participants === 6) {
          return Number(this.tourData.guiderPayment + 15).toFixed(2);
        }

        return Number(this.tourData.guiderPayment * nOfTickets).toFixed(2);
      }

      return Number(sharedTourPayment); */
      const price = this.tourData.privatePrice - 20;
      return Number(price).toFixed(2);
    },
    websiteFee() {
      // const nOfTickets = this.participants % 4
      /* const price = this.isPrivateTour
        ? (this.privatePrice - this.guiderPayment).toFixed(2)
        : (10 * this.participants).toFixed(2);
      if (this.tourData.isPrivateOnly) {
        return `20 €`;
      } */
      const price = 20;
      return `${price} €`;
    },
    bookingValidation() {
      const {
        bookingTime,
        bookingDate,
        participants,
        fullName,
        email,
        phoneNumber,
      } = this;
      return {
        bookingTime,
        bookingDate,
        participants,
        fullName,
        email,
        phoneNumber,
      };
    },
    sharedTimeSlots() {
      return this.tourData?.sharedTimeSlots?.length
        ? this.tourData?.sharedTimeSlots
        : this.defaultSharedTimeSlots;
    },
    privateTimeSlots() {
      return this.tourData?.privateTimeSlots?.length
        ? this.tourData?.privateTimeSlots
        : this.defaultPrivateTimeSlots;
    },
    humanizedDate() {
            return this.bookingDate
        ? this.bookingDate.toLocaleDateString(this.dateLocale, { weekday: "short", day: "numeric", month: "long", year: "numeric" })
        : "";
    },
    privatePrice() {
      /* const nOfTickets = this.participants / 4
      const nOfPrivateTickets = Math.ceil(nOfTickets)
      this.setNOfPrivateTickets(nOfPrivateTickets)
      return this.tourData?.privatePrice * nOfPrivateTickets
   */
      const nOfTickets = this.participants / 4;
      const nOfPrivateTickets = Math.ceil(nOfTickets);
      this.setNOfPrivateTickets(nOfPrivateTickets);
      let totalPrice = this.tourData?.privatePrice;

      if (
        this.tourData.isPrivateOnly &&
        this.participants > 4 &&
        this.participants <= 8
      ) {
        totalPrice = this.tourData.price;
        return totalPrice;
      }

      if (this.participants === 5) {
        totalPrice += 15;
        return totalPrice;
      }
      if (this.participants === 6) {
        totalPrice += 30;
        return totalPrice;
      }
      return this.tourData?.privatePrice * nOfPrivateTickets;
    },
    timeSlots() {
      return this.isPrivateTour ? this.privateTimeSlots : this.sharedTimeSlots;
    },
    minDate() {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // normalize to midnight
      return today;
      /*  const today = new Date();
      const openingDate = new Date(today.getFullYear(), 8, 15);

      return openingDate >= today ? openingDate : today;

       return this.isPrivateTour
        ? new Date(today.getFullYear(), today.getMonth(), today.getDate())
        : new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1); */
    },
  },
  watch: {
    isTicketUpgraded() {
      if (
        this.originalTourData.id === "Wtc6b2YdHZo9lvHllBuZ" &&
        this.isTicketUpgraded
      ) {
        this.updateSelectedTourData("mvNB6IUvD9rlOzTeisIW");
      } else {
        this.tourData = this.originalTourData;
      }
    },
    bookingValidation: {
      handler: function () {
        const hasBasicInfo =
          this.participants !== 0 &&
          this.isValidPhoneNumber(this.phoneNumber) &&
          this.bookingDate &&
          this.fullName.trim().length > 0 &&
          this.email.trim().length > 0;

        this.isBookingValid = this.tourData?.isPass
          ? hasBasicInfo
          : hasBasicInfo && this.bookingTime;
      },
      deep: true,
    },

    bookingDate(value) {
      let date = new Date(value);
      if (
        value.toLocaleDateString() === date.toLocaleDateString() &&
        new Date().getHours() >= 8
      ) {
        if (new Date().getHours() > 16) {
          let min = new Date();
          min.setHours(min.getHours() + 4);
          min.setMinutes(min.getMinutes());
          this.minTime = min;
        }
      } else if (
        new Date().getHours() <= 16 ||
        value.toLocaleDateString() !== date.toLocaleDateString()
      ) {
        let min = new Date();
        min.setHours(8);
        min.setMinutes(0);
        this.minTime = min;
      }
    },
  },
  mounted() {
    // vue-tel-input doesn't forward inputmode, so set it on the real input
    // to get a digits-only keyboard on phones.
    this.$refs.phoneInput?.$refs.input?.setAttribute("inputmode", "numeric");
  },
  created() {
    this.fetchTickets();
    this.tourData = this.originalTourData;
    
  },
    methods: {
    // "14 October" / "14 de outubro"... in the visitor's language
    formatDay(date) {
      if (!date) return "";
      return new Date(Number(date)).toLocaleDateString(this.dateLocale, { month: "long", day: "numeric" });
    },
    isValidPhoneNumber(number) {
      const phoneNumber = parsePhoneNumberFromString(number);
      return phoneNumber ? phoneNumber.isValid() : false;
    },
    /*  sendFreeTicket() {
      try {
        if (this.subscribeClientToNewsletter) {
          await this.subscribeToNewsletter();
        }

        if (!this.tourData.price) {
          this.sendFreeTicket();
          return;
        }
        // Get affiliate id (if exists)
        const affiliate_id = await this.checkIfAffiliateExists(
          this.$route?.query?.referral
        );

        this.isLoadingBooking = true;

        // Build request payload
        const data = {
          cancelUrl: `https://guiders.pt/details/${this.$route.params.id}/${this.$route.params.name}`,
          //priceLink: "price_1S50pLJou6FLnGKIIRvtCexA",
          priceLink: this.tourData.priceLink,
          quantity: this.participants,
          metadata: {
            selectedPass: this.tourData.id,
            isPass: true,
            dateOfPurchase: new Date(),
            expectedDateOfUse: this.bookingDate.setHours(0, 0, 0, 0),
            buyerData: JSON.stringify({
              phoneNumber: this.phoneNumber.replace(/[^0-9+]/g, ""),
              name: this.fullName,
              email: this.email,
            }),
            meetingPoint: this.tourData.meetingPoint,
            duration: this.tourData.duration,
            cancellationPolicy: this.tourData.cancellationPolicy,
            numberOfTickets: this.participants,
            selectedPaymentOption: "Stripe",
            totalPrice: this.tourData?.price * this.participants,
            affiliate_id: affiliate_id || null,
            saleSource: affiliate_id ? "Partner Link" : "Direct Sale",
          },
        };

        // Send request
        const response = await fetch(
          `${process.env.VUE_APP_API_URL}/stripe/pass/get`,
          {
            method: "POST",
            body: JSON.stringify(data),
            headers: { "Content-Type": "application/json" },
            credentials: "same-origin",
          }
        );

        const result = await response.json();

        if (result.success) {
          this.isLoadingBooking = false;
          window.location.href = result.message.url;
        } else {
          this.$buefy.toast.open({
            duration: 10000,
            message:
              result.message?.raw?.message ||
              this.$t("booking.error"),
            position: "is-bottom",
            type: "is-danger",
          });
          this.isLoadingBooking = false;
        }
      } catch (error) {
        console.error("❌ Booking error:", error);
        this.$buefy.toast.open({
          duration: 10000,
          message:
            this.$t("booking.error"),
          position: "is-bottom",
          type: "is-danger",
        });
        this.isLoadingBooking = false;
      }
    }, */
    async updateSelectedTourData(id) {
      try {
        const docRef = await db.firestore().collection("tours").doc(id).get();
        if (docRef.exists) {
          this.tourData = docRef.data();
        }
      } catch {
        console.log("Activity not found");
      }
    },
    formatDate(date) {
      if (!(date instanceof Date)) {
        date = new Date(date); // Convert if it's a timestamp or string
      }
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    async fetchTickets() {
      const now = new Date();
      now.setHours(0, 0, 0, 0); // set time to 00:00:00.000
      const todayMidnightTimestamp = now.getTime().toString();
      const snapshot = await db
        .firestore()
        .collection("passes")
        .where("expectedDateOfUse", ">=", todayMidnightTimestamp) // stored as string
        .get();

      const grouped = {};

      snapshot.forEach((doc) => {
        const data = doc.data();
        const timestampMs = parseInt(data.expectedDateOfUse);
        const dateObj = new Date(timestampMs).setHours(0, 0, 0, 0);
        const dateStr = this.formatDate(dateObj);

        const numTickets = Number(data.numberOfTickets);
        grouped[dateStr] = (grouped[dateStr] || 0) + numTickets;
      });
      this.ticketsByDate = grouped;

      // Precompute disabled dates
      this.disabledDates = Object.entries(grouped)
        .filter((count) => count[1] >= this.MAX_TICKETS)
        .map(([dateStr]) => {
          const [y, m, d] = dateStr.split("-").map(Number);
          return new Date(y, m - 1, d); // month is 0-based
        });
      console.log(this.disabledDates);
      this.setSoldOutDates(this.disabledDates);
    },
    async getActivityById(id) {
      try {
        const docRef = await db.firestore().collection("tours").doc(id).get();
        if (docRef.exists) {
          return docRef.data();
        } else {
          return {};
        }
      } catch (error) {
        return {};
      }
    },
    setSoldOutDates(disabledDates) {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Normalize time to 00:00

      const dates = [];
      const minDate = today;

      // Add all dates before the minimum allowed date (starting from the day before)
      const currentDate = new Date(minDate);
      currentDate.setDate(currentDate.getDate() - 1);

      while (currentDate >= new Date(today.getFullYear(), 0, 1)) {
        dates.push({
          date: new Date(currentDate),
          type: "is-danger",
        });
        currentDate.setDate(currentDate.getDate() - 1);
      }

      // Add disabledDates that are in the past
      const soldOutDates = disabledDates
        .filter((date) => {
          const d = new Date(date);
          d.setHours(0, 0, 0, 0);
          return d < today;
        })
        .map((date) => ({
          date: new Date(date),
          type: "is-danger",
        }));

      this.soldOutDates = [...dates, ...soldOutDates];
      console.log({ dates, soldOutDates });
    },
    isTimeValid(time) {
      // Get the current time
      // var currentTime = new Date().setHours(19 + 2, 0, 0, 0);
      if (!this.bookingDate) return true;
      let dateToday = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
      );

      if (this.bookingDate > dateToday) return false;
      var currentTime = new Date();
      currentTime.setHours(currentTime.getHours() + 1); // Add 2 hours in the future so we have time to get a driver

      const formattedTime = time.split(":");
      const hours = formattedTime[0];
      const minutes = formattedTime[1];

      var targetTime = new Date();
      targetTime.setHours(hours, minutes, 0, 0);

      return currentTime > targetTime;
    },
    setNOfPrivateTickets(nOfTickets) {
      this.nOfPrivateTickets = nOfTickets;
    },
    subscribeToNewsletter() {
      //TODO
      console.log("has been subscribed to newsletter");
    },
    async redirect() {
      if (this.tourData?.isPass) {
        this.buyPass();
        return;
      }
      this.buyNormalTicket();
    },
    async checkIfAffiliateExists(vendorId) {
      const vendorRef = db.firestore().collection("vendors").doc(vendorId); // Reference to the document
      const vendorSnap = await vendorRef.get(); // Fetch the document

      return vendorSnap.exists ? vendorId : false; // Return ID if exists, else undefined
    },
    async buyPass() {
      try {
        if (this.subscribeClientToNewsletter) {
          await this.subscribeToNewsletter();
        }

        /*  if (!this.tourData.price) {
          this.sendFreeTicket();
          return;
        } */
        // Get affiliate id (if exists)
        const affiliate_id = await this.checkIfAffiliateExists(
          this.$route?.query?.referral,
        );

        this.isLoadingBooking = true;

        // Build request payload
        const data = {
          cancelUrl: `https://guiders.pt${this.$route.fullPath}`,
          promoteboost_referral: window.promoteboost_referral,
          priceLink: this.tourData.priceLink,
          testPurchase: this.testPurchase,
          quantity: this.participants,
          metadata: {
            selectedPass: this.tourData.id,
            isPass: true,
            dateOfPurchase: new Date(),
            expectedDateOfUse: this.bookingDate.setHours(0, 0, 0, 0),
            buyerData: JSON.stringify({
              phoneNumber: this.phoneNumber.replace(/[^0-9+]/g, ""),
              name: this.fullName,
              email: this.email,
            }),
            meetingPoint: this.tourData.meetingPoint,
            duration: this.tourData.duration,
            cancellationPolicy: this.tourData.cancellationPolicy,
            numberOfTickets: this.participants,
            selectedPaymentOption: "Stripe",
            totalPrice: this.tourData?.price * this.participants,
            affiliate_id: affiliate_id || null,
            saleSource: affiliate_id ? "Partner Link" : "Direct Sale",
          },
        };

        // Send request
        const response = await fetch(
          `${process.env.VUE_APP_API_URL}/stripe/pass/get`,
          {
            method: "POST",
            body: JSON.stringify(data),
            headers: { "Content-Type": "application/json", ...(this.testPurchase ? await authHeaders() : {}) },
            credentials: "same-origin",
          },
        );

        const result = await response.json();

        if (result.success) {
          this.isLoadingBooking = false;
          window.location.href = result.message.url;
        } else {
          this.$buefy.toast.open({
            duration: 10000,
            message:
              result.message?.raw?.message ||
              this.$t("booking.error"),
            position: "is-bottom",
            type: "is-danger",
          });
          this.isLoadingBooking = false;
        }
      } catch (error) {
        console.error("❌ Booking error:", error);
        this.$buefy.toast.open({
          duration: 10000,
          message:
            this.$t("booking.error"),
          position: "is-bottom",
          type: "is-danger",
        });
        this.isLoadingBooking = false;
      }
    },

    async buyNormalTicket() {
      if (this.subscribeClientToNewsletter) this.subscribeToNewsletter();
      this.isLoadingBooking = true;
      const duration = convertMinutesToHoursAndMinutes(this.tourData.duration);
      const endTime = addDurationToTime(
        this.bookingTime,
        duration.hours,
        duration.minutes,
      );

      const bookingDate = this.bookingDate.setHours(0, 0, 0, 0);
      /*  const privateOnlyIds = ["D1YH6p0pVThgornEsYhe"];
      const isPrivateOnly = privateOnlyIds.includes(this.tourData.id);
      let priceLink= null
      if (isPrivateOnly) {
        priceLink=  'price_1PUs9AJou6FLnGKIs07dcy3t'
      } */
      let data = {
        cancelUrl: `https://guiders.pt${this.$route.fullPath}`,
        promoteboost_referral: window.promoteboost_referral,
        /*  priceLink: priceLink ? priceLink : ( !this.isPrivateTour
          ? this.tourData.sharedPriceLink
          : this.tourData.priceLink), */
        priceLink: this.tourData.priceLink,
        /*  !this.isPrivateTour
          ? this.tourData.sharedPriceLink
          : this.tourData.priceLink, */
        quantity: this.tourData.isPrivateOnly
          ? 1
          : this.isPrivateTour
          ? this.nOfPrivateTickets
          : this.participants,
        metadata: {
          tourName: this.tourData.title,
          activityId: this.tourData.id,
          clientId: this.user.uid,
          clientName: this.fullName,
          clientEmail: this.email,
          meetingPoint: this.tourData.meetingPoint,
          date: bookingDate,
          time: this.bookingTime,
          endTime,
          duration: this.tourData.duration,
          cancellationPolicy: this.tourData.cancellationPolicy,
          numOfTickets: this.participants,
          maxNumOfParticipants: this.tourData?.maxNumOfParticipants,
          minNumOfParticipants: this.tourData?.minNumOfParticipants,
          isPrivateTour: this.isPrivateTour,
          remainingPayment: this.guiderPayment,
        },
      };

      await fetch(`${process.env.VUE_APP_API_URL}/stripe/session`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            this.isLoadingBooking = false;
            window.location.href = data.message.url;
          } else {
            this.$buefy.toast.open({
              duration: 10000,
              message:
                data.message.raw.message ||
                this.$t("booking.error"),
              position: "is-bottom",
              type: "is-danger",
            });
            this.isLoadingBooking = false;
          }
        })
        .catch((error) => {
          this.$buefy.toast.open({
            duration: 10000,
            message:
              this.$t("booking.error"),
            position: "is-bottom",
            type: "is-danger",
          });
          this.isLoadingBooking = false;
          console.log(error.message);
          return true;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.radio--input {
  display: flex;
  padding: 1rem;
  border: 1px solid #ededed;
  border-radius: 5px;
  p {
    margin-left: 1.8rem;
    margin-top: 0.5rem;
  }
}
.sold-out-bar {
  background-color: #f14668;
  height: 0.25em;
  width: 1.75rem;
  margin-right: 0.5rem;
}
.available-tag {
  background-color: #def7eb !important;
  color: #33ca7f !important;
  width: -webkit-fill-available;
  display: flex;
  justify-content: flex-start;
  font-weight: 500 !important;
}
.help,
.info {
  padding: 5px 10px;
  border-radius: 20px;
  font-weight: 500;
  margin-top: 1.5rem;
  font-size: 14px;
}

.help {
  color: #fe6261;
  background-color: #fe62610f;
}

.info {
  color: #446df6;
  background-color: #ecf3ff;
  padding: 13px 10px;
  border-radius: 10px;
  .link {
    color: #446df6;
  }
}

.tour--img {
  height: 120px;
  width: -webkit-fill-available;
}

.tour-type--cnt {
  color: #2c2c2c;
  border-radius: 8px;
  padding: 8px 12px;

  .icon {
    height: 1.2rem;
    object-fit: contain;
  }

  &.selected {
    color: #fff;
    background-color: #2c2c2c; // box-shadow: 0 0 0 2px #2C2C2C;
  }
}

.page-title {
  font-size: 22px;
}

.message--info {
  padding: 20px;
  border-radius: 10px;
  background-color: #d5ebff33;

  .is-size-6 {
    font-size: 1.05rem !important;
  }
}


.button.is-large {
  height: 2.5rem;
  font-size: 1rem;
}

.calendar-icon {
  height: 40px;
  width: 40px;

  img {
    height: 1.25em;
    width: 1.5em;
  }
}

.b-radio.radio.button.is-primary.is-selected {
  background-color: var(--primary);
  color: #fff;
}

.modal .modal-close {
  top: 34px;
}

.field.has-addons .control .button {
  border-bottom-left-radius: 60px;
  border-top-left-radius: 60px;
  border-bottom-right-radius: 60px;
  border-top-right-radius: 60px;
}

.field.has-addons .control .button {
  border-radius: 60px !important;
  font-weight: 500;
}

/*.timeslots{
  .button {
    border: 2px solid #2C2C2C;
}
}*/

::v-deep {
  .vue-tel-input {
    border-radius: 5px;
    border: 1px solid #e2e9ec;
    text-align: left;
    .vti__input {
      font-size: 1rem !important;
      color: rgba(23, 17, 56, 0.6509803922);
    }
  }
  .b-radio.radio[disabled] {
    opacity: 0.3;
    background-color: #e0ebef;
    border-color: transparent;
  }

  .label:not(:last-child) {
    margin-bottom: 1em;
  }

  .field.has-addons .control .button {
    border-radius: 60px !important;
    font-weight: 500;
  }

  .tag:not(body).is-light {
    background-color: #f7fbff;
    color: #2c2c2c;
    font-weight: 600;
    font-size: 0.85rem;

    .icon {
      height: 1rem;
      object-fit: contain;
    }
  }

  .tags {
    color: #2c2c2c;
    font-weight: 600;
    font-size: 0.85rem;

    .icon {
      height: 1rem;
      object-fit: contain;
    }
  }

  .timeslots {
    .field.has-addons {
      gap: 0.5rem;
      display: grid;
      grid-template-columns: repeat(4, minmax(min-content, 1fr));
    }
  }

  .b-tabs .tab-content {
    padding: 0;
  }

  footer.modal-card-foot {
    background-color: white !important;
  }

  footer.modal-card-foot {
    background-color: white !important;
  }

  .timepicker {
    .field.has-addons {
      display: grid;
      grid-template-columns: repeat(3, minmax(max-content, 1fr));
    }
  }

  .b-numberinput input[type="number"] {
    width: 40px;
  }

  .b-numberinput.field.is-grouped div.control {
    -webkit-box-flex: 0;
    -ms-flex-positive: 1;
    flex-grow: 0;
    flex-shrink: 0;
  }

  .participants-field {
    .input {
      border-color: transparent;
    }

    .control {
      .button.is-primary[disabled],
      .button.is-primary {
        background-color: transparent;
        border-color: transparent;
        color: #2c2c2c;
      }

      .button.is-primary[disabled] {
        opacity: 0.1;
      }
    }
  }
}

::v-deep .is-large.delete,
.is-large.modal-close {
  background-color: #2c2c2c !important;
}

.buttons {
  margin-top: 42px;
}

.select select,
.taginput .taginput-container.is-focusable,
.input {
  margin-bottom: 0;
}

.date {
  .select select {
    border-color: transparent;
  }
}
.datepicker .datepicker-table .datepicker-cell {
  border-radius: 3;
}

.datepicker .dropdown-item,
.datepicker .dropdown .dropdown-menu .has-link a,
.dropdown .dropdown-menu .has-link .datepicker a {
  font-size: inherit;
  padding: 0;
}

.datepicker .dropdown .input[readonly],
.datepicker .dropdown-trigger .input[readonly] {
  cursor: pointer;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.datepicker .dropdown-content {
  background-color: transparent;
  border-radius: 4px;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.datepicker .dropdown .input,
.datepicker .dropdown-trigger .input {
  cursor: pointer;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.column.book-column {
  height: 100vh;
}

.booking-container {
  padding: 32px;
  border-radius: 8px;
  background-color: #f9f9f9;
  color: #f9f9f9;
  margin: 95px 0px;
}

.timepicker select {
  background-color: transparent;
}

@media only screen and (max-width: 768px) {
  .dropdown-item,
  .dropdown .dropdown-menu .has-link a {
    padding: 0;
    margin: 24px 0px;
  }
}

.dropdown-item,
.dropdown .dropdown-menu .has-link a {
  margin: 0;
}

.page-footer {
  bottom: 0;
  background-color: whitesmoke;
  width: 100%;
  position: fixed;
  left: 0;
  padding: 20px;
}

.modal-body {
  border-radius: 8px;
  padding: 20px;
  background-color: white;
  width: -webkit-fill-available;
  min-height: auto;
  border: 1px solid #edebf2;
  &::-webkit-scrollbar {
    display: none;
  }
}

section .modal-content,
.modal-card {
  max-height: 100%;
}

.level-item {
  align-items: end;
  justify-content: flex-end;
}

.margin {
  margin: 42px 0px;
}

.title.is-4 {
  padding-bottom: 32px;
}
</style>
